// StripeReturn.jsx : après succès
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../../../../config.json";
import { toast } from "react-toastify";

const StripeReturn = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkStripeStatus = async () => {
      const queryParams = new URLSearchParams(location.search);
      const restaurantId = queryParams.get("restaurantId");

      if (!restaurantId) return;

      try {
        const response = await axios.get(
          `${config.dev}/v2/restaurant/stripe/status/${restaurantId}`
        );

        if (response.data.success) {
          toast.success("Stripe onboarding completed!");
        } else {
          toast.warning("Stripe account not yet verified.");
        }

        navigate("/app-profile");
      } catch (error) {
        console.error("Erreur vérification Stripe :", error);
        toast.error("Error verifying Stripe account.");
      }
    };

    checkStripeStatus();
  }, []);

  return (
    <div className="text-center mt-5">
      <h3>Stripe account verification in progress..</h3>
    </div>
  );
};

export default StripeReturn;
